export default function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

export function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-color/src/define.js
// module id = 131
// module chunks = 0